var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "md", modalId: "modal-lv3" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", { staticClass: "font-semibold text-base mb-5" }, [
              _vm._v(_vm._s(_vm.updatedWebsite ? "Edit" : "Add") + " website"),
            ]),
            _c(
              "span",
              {
                staticClass:
                  "cursor-pointer flex items-center justify-center absolute top-4 right-5",
                on: {
                  click: _vm.closeModal,
                  mouseover: function ($event) {
                    _vm.isHovered = true
                  },
                  mouseout: function ($event) {
                    _vm.isHovered = false
                  },
                },
              },
              [
                !_vm.isHovered
                  ? _c("CrossIcon", { staticClass: "h-3.5 w-3.5" })
                  : _vm._e(),
                _vm.isHovered
                  ? _c("CrossIconHover", { staticClass: "close-icon" })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("ModalContent", { staticClass: "relative" }, [
              _c("div", { attrs: { id: "websiteslot" } }, [
                _c(
                  "div",
                  { staticClass: "mt-5" },
                  [
                    _c("ValidationProvider", {
                      attrs: { rules: "url" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ errors }) {
                            return [
                              _c("FormGroup", {
                                staticClass: "mt-6",
                                attrs: {
                                  name: "website",
                                  title: "",
                                  type: "search",
                                  placeholder: "URL here",
                                  errors: errors,
                                  inputClass: "fullwidthInput",
                                  isIcon: false,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c("p", { staticClass: "mb-2" }, [
                                            _c(
                                              "span",
                                              { staticClass: "required-icon" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v("Website URL "),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.website,
                                  callback: function ($$v) {
                                    _vm.website = $$v
                                  },
                                  expression: "website",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-end mt-2 pt-3 gap-4",
                                },
                                [
                                  _c("UIButton", {
                                    attrs: {
                                      buttonText: "Cancel",
                                      size: "lg",
                                      variant: "outline",
                                      processing: _vm.processing,
                                    },
                                    on: { click: _vm.closeModal },
                                  }),
                                  !_vm.updatedWebsite
                                    ? _c("UIButton", {
                                        attrs: {
                                          buttonText: "Add",
                                          size: "lg",
                                          variant: "black",
                                          processing: _vm.processing,
                                          disabled:
                                            !_vm.website || !!errors.length,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addWebsite()
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.updatedWebsite
                                    ? _c("UIButton", {
                                        attrs: {
                                          buttonText: "Save",
                                          size: "lg",
                                          variant: "black",
                                          processing: _vm.processing,
                                          disabled: !!errors.length,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editWebsite()
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }